import produce from "immer";
import first from "lodash/first";
import pullAllBy from "lodash/pullAllBy";
import { CustomizationState } from "../";
import { checkAndFillInitialPages } from "../../../utils/customization/content";
import { findPageAndDefinition, findPageDefinition } from "../../../utils/customization/finders";
import { addPageMutation, generateNewPage } from "../../../utils/customization/page";

export interface RemovePageAction {
  type: "removePage";
  pageKey: string;
}

export function removePage(
  state: CustomizationState,
  action: RemovePageAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { pageKey } = action;
    const { content, template } = draftState;

    // check if page is required before removing
    const { page, pageDefinition } = findPageAndDefinition(pageKey, template, content);
    const requiredInitialPageFilters = template.contentPageConfiguration.forcedLayouts.map(
      ({ filterType }) => filterType
    );
    const countRequiredPagesOfFilterType = requiredInitialPageFilters.reduce(
      (count, filterType) => {
        if (filterType === pageDefinition.filterType) {
          return count + 1;
        }
        return count;
      },
      0
    );
    const sameFilterTypePages = content.pages.filter((contentPage) => {
      const currentPageDefinition = findPageDefinition(contentPage.pageDefinitionKey, template);
      return currentPageDefinition.filterType === pageDefinition.filterType;
    });

    if (sameFilterTypePages.length > countRequiredPagesOfFilterType) {
      pullAllBy(content.pages, [{ key: pageKey }], "key");
    } else {
      page.editablePictures = [];
      page.editableTexts = [];
    }

    if (
      content.pages.length === 0 &&
      template.contentPageConfiguration.forcedLayouts.length === 0
    ) {
      const firstTemplatePageDefinition = first(template.pageDefinitions);
      if (!firstTemplatePageDefinition) {
        return;
      }
      const newPage = generateNewPage(firstTemplatePageDefinition.key, template);
      addPageMutation(newPage, content);
    } else {
      content.pages = checkAndFillInitialPages(content, template);
    }
  });
}
